import { AddFluxHOCProps, addFlux } from 'components/wrappers/WithFlux';
import { Filter } from 'model/Filters';
import useMoreFilters from 'modules/common/Popovers/MoreFiltersPopover/hooks/useMoreFilters';
import MoreFiltersPopover from 'modules/common/Popovers/MoreFiltersPopover/index';
import { PopoverTriggerSource } from 'modules/common/SubBars/ExperienceFilterSubNavbar/usePopoverTrigger';
import React, { useMemo } from 'react';

interface MoreFiltersPopoverProps {
  initialSelectedFilters: Filter[];
  onClose: (args: {
    source: PopoverTriggerSource;
    callback?: () => void;
  }) => void;
}

function MoreFiltersPopoverContainer({
  initialSelectedFilters,
  onClose,
  flux,
}: MoreFiltersPopoverProps & AddFluxHOCProps) {
  const { aggregations, city, country } = useMemo(() => {
    const { city, country } = flux.stores.FiltersStore.getFilters();
    return {
      aggregations: flux.stores.SearchStore.getAggregations(
        flux.stores.FiltersStore.getFilters(),
      ),
      city,
      country,
    };
  }, [flux]);

  const { onClear, onApply, results, activeFilters, actions } = useMoreFilters({
    initialSelectedFilters,
    onClose,
    aggregations,
    city,
    country,
  });

  return (
    <MoreFiltersPopover
      onApply={onApply}
      onClear={onClear}
      aggregations={aggregations}
      activeFilters={activeFilters}
      actions={actions}
      amountOfResults={results.amountOfResults}
      resultsLoading={results.resultsLoading}
    />
  );
}

export default addFlux(MoreFiltersPopoverContainer);
